import '../../../css/Products/ProductLoading.css';

function ProductLoading({theme}) {
    return (
        <div className='jflldkm35'>

            <div className='kfjjek3cx'>
                <div className={`jjfknn353 ${theme} shimmer`}></div>
            </div>

            <div className='kdjjfnek3'>
                <div className={`fggfvbcds ${theme} shimmer`}></div>
            </div>
            
        </div>
    )
}

export default ProductLoading